import {createSvgIcon} from "@mui/material";

export const TimesIcon = createSvgIcon(
    <svg width="24" height="24" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g>
        <line
            x1="5.84"
            y1="5.84"
            x2="42.16"
            y2="42.16"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="2"
            strokeMiterlimit="10"
            fill="none"
        />
        <line
            x1="42.16"
            y1="5.84"
            x2="6.09"
            y2="41.91"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="2"
            strokeLinejoin="round"
            fill="none"
        />
      </g>
    </svg>,
    'TimesIcon'
)